export type FeatureFlag = "FEATURE_HOME_CHAT";

const TRUTHY_VALUES = new Set(["1", "true", "yes", "on"]);

const FEATURE_FLAG_ENV_KEYS: Record<FeatureFlag, readonly string[]> = {
  // ANA-263 — gates the Home Chat surface (lobby composer + voice + suggestion
  // pills + the /chat thread). Default off: Home Chat is admin-only until this
  // flips on, at which point every user sees it again. The flag is the single
  // "ship to everyone" lever — re-enabling needs no code change.
  FEATURE_HOME_CHAT: ["VITE_FEATURE_HOME_CHAT", "FEATURE_HOME_CHAT"],
};

function readImportMetaEnvValue(key: string): string | undefined {
  if (typeof import.meta !== "undefined" && import.meta.env) {
    const value = import.meta.env[key];
    return typeof value === "string" ? value : undefined;
  }

  return undefined;
}

function readProcessEnvValue(key: string): string | undefined {
  if (typeof process !== "undefined" && process.env) {
    return process.env[key];
  }

  return undefined;
}

export function parseBooleanFlag(value: string | undefined): boolean {
  if (!value) return false;
  return TRUTHY_VALUES.has(value.trim().toLowerCase());
}

function getFeatureFlagValue(flag: FeatureFlag): string | undefined {
  const keys = FEATURE_FLAG_ENV_KEYS[flag];

  for (const key of keys) {
    const processValue = readProcessEnvValue(key);
    if (processValue !== undefined) return processValue;

    const importMetaValue = readImportMetaEnvValue(key);
    if (importMetaValue !== undefined) return importMetaValue;
  }

  return undefined;
}

export function isFeatureEnabled(flag: FeatureFlag): boolean {
  return parseBooleanFlag(getFeatureFlagValue(flag));
}

export function isHomeChatEnabled(): boolean {
  return isFeatureEnabled("FEATURE_HOME_CHAT");
}
